/** @jsx jsx */
import { jsx } from '@emotion/react';
import styled from '@emotion/styled';
import { FormattedMessage } from 'react-intl-next';
import { B50, N20A, N800 } from '@atlaskit/theme/colors';
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports
import { borderRadius, gridSize } from '@atlaskit/theme/constants';
import { PersonIcon } from '../icons/person';
import { ProfilePicture } from '../profile-picture';
import { SkeletonText } from '../skeleton-text';
export var AccountDetails = function AccountDetails(_ref) {
  var testId = _ref.testId,
    name = _ref.name,
    picture = _ref.picture,
    email = _ref.email,
    managedBy = _ref.managedBy;
  return jsx(Container, {
    "data-testid": testId
  }, managedBy && jsx(ManagedBy, null, jsx(PersonIconWrapper, null, jsx(PersonIcon, {
    label: "",
    size: "small"
  })), jsx(FormattedMessage, {
    id: "identity.account-menu.account-menu-details.managed-account",
    defaultMessage: "This account is managed by <b>{managedBy}</b>",
    description: "Label showing the user which organisation manages their Atlassian account",
    values: {
      b: function b(text) {
        return jsx("strong", null, text);
      },
      managedBy: managedBy
    }
  })), jsx(Content, {
    hasHeader: !!managedBy
  }, jsx(Profile, {
    testId: testId,
    name: name,
    picture: picture,
    email: email
  })));
};
var Container = styled.section({
  display: 'flex',
  flexDirection: 'column',
  margin: "0 ".concat("var(--ds-space-100, 8px)")
});
var ManagedBy = styled.small({
  display: 'box',
  margin: '0px',
  padding: "var(--ds-space-025, 2px)".concat(" ", "var(--ds-space-100, 8px)"),
  textAlign: 'center',
  borderRadius: "".concat(borderRadius(), "px ").concat(borderRadius(), "px 0 0"),
  background: "var(--ds-background-information, ".concat(B50, ")"),
  color: "var(--ds-text-subtle, #44546F)"
});
var PersonIconWrapper = styled.span({
  marginRight: "var(--ds-space-050, 4px)",
  '& > span': {
    width: '12px',
    height: '12px'
  }
});
var Content = styled.div({
  display: 'flex',
  flexDirection: 'column',
  background: "var(--ds-surface-sunken, ".concat(N20A, ")")
}, function (_ref2) {
  var hasHeader = _ref2.hasHeader;
  return {
    borderRadius: hasHeader ? "0 0 ".concat(borderRadius(), "px ").concat(borderRadius(), "px") : "".concat(borderRadius(), "px")
  };
});
var Profile = function Profile(_ref3) {
  var name = _ref3.name,
    email = _ref3.email,
    picture = _ref3.picture,
    testId = _ref3.testId;
  return jsx(ProfileWrapper, null, jsx(ProfilePicture, {
    src: picture,
    size: gridSize() * 8,
    testId: testId && "".concat(testId, "--picture")
  }), jsx(NameAndEmail, null, jsx(DisplayName, {
    "data-testid": testId && "".concat(testId, "--name")
  }, name || jsx(SkeletonText, {
    length: "6em"
  })), jsx(EmailAddress, {
    "data-testid": testId && "".concat(testId, "--email")
  }, email || jsx(SkeletonText, {
    length: "10em"
  }))));
};
var ProfileWrapper = styled.div({
  display: 'flex',
  flexDirection: 'row',
  margin: "var(--ds-space-200, 16px)".concat(" ", "var(--ds-space-200, 16px)")
});
var NameAndEmail = styled.div({
  display: 'flex',
  flexDirection: 'column',
  margin: "auto 0 auto ".concat("var(--ds-space-200, 16px)")
});
var DisplayName = styled.h3({
  color: "var(--ds-text, ".concat(N800, ")"),
  margin: 0
});
var EmailAddress = styled.p({
  marginTop: "var(--ds-space-025, 2px)",
  color: "var(--ds-text-subtlest, #626F86)",
  fontWeight: 400
});